import constructFabricUrl from 'commons/constructFabricUrl';

const getOptionURL = (fabricName, optionValue) => {
  const option_url = optionValue
    .trim()
    .toLowerCase()
    .replace(/ /g, '-');

  return fabricName === 'Wood Stain' ? '#' : `swatches/swatch/${option_url}`;
};

const parseGroupMaterial = groupMaterial => {
  try {
    const parsed = JSON.parse(groupMaterial);
    return Array.isArray(parsed) ? parsed : [parsed];
  } catch {
    return [groupMaterial];
  }
};

export const fabricObject = fabric => ({
  option: {
    type: fabric.option_name,
    group: fabric.group_name,
    color: fabric.option_color,
    pet_friendly: !!fabric.pet_friendly,
    sustainable_fabric: fabric.sustainable_fabric,
    material: fabric.group_material_desc || '',
    cleaning_code: fabric.group_cleaning_code || '',
    tier: fabric.option_value_tier || '',
    id: fabric.option_value_id,
    groupMaterial: parseGroupMaterial(fabric.group_material),
    description: (fabric.option_description || '').replace(/(<([^>]+)>)/gi, ''),
  },
  linkButton: {
    link: getOptionURL(fabric.option_name, fabric.option_value),
    content: fabric.option_value,
  },
  alignment: 'middle',
  subTitle: {
    name:
      fabric.option_description !== null
        ? fabric.option_description.replace(/(<([^>]+)>)/gi, '')
        : '',
    style: {
      color: '#FFFFFF',
      maxWidth: '231px',
      fontSize: '12px',
    },
  },
  imageProps: {
    src:
      fabric.option_name === 'Fabric'
        ? constructFabricUrl(
            fabric.option_value,
            null,
            'shop-color',
            fabric.option_value_id
          ).transparent_config_image
        : `https://joybird2.imgix.net/option_images/swatches/290x290-${fabric.option_image}`,
    fallbackSrc: `https://joybird2.imgix.net/option_images/swatches/290x290-${fabric.option_image}`,
    height: 300,
    width: 650,
  },
  footerTitle: {
    style: {
      fontSize: '12px',
      color: '#585858',
    },
    name: fabric.option_value,
  },
});
